<template>
       
        <div class="modal-card">
 

            <header class="modal-card-head">
                 
            </header>


            <section class="modal-card-body">

                <b-field label="member_id"
                         horizontal 
                         :type="dataToChild.member_id.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_ID   ? '' : 'is-danger'"
                         :message="dataToChild.member_id.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_ID    ? '' : 'invalid'"
                          >
                        <template #label>
                           Member ID  
                            <span :class="dataToChild.member_id.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_ID ? 'has-text-info'  : 'has-text-danger' " 
                              v-if="dataToChild.member_id && dataToChild.member_id.length>0">
                               (  {{dataToChild.member_id.length}}/{{GLOBAL_VAR.MAX_PATHO_MEMBER_ID}} ) 
                            </span>
                        </template>  
                        <b-input v-model="dataToChild.member_id"  placeholder="Auto Generate" :disabled="mode==1 || mode==0" ></b-input>
                </b-field>


                <b-field label="name"
                         horizontal 
                         :type="dataToChild.name.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_NAME   ? '' : 'is-danger'"
                         :message="dataToChild.name.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_NAME    ? '' : 'invalid'"
                         >
                        <template #label>
                           ชื่อ  <span class="has-text-danger">*</span>  
                           <span :class="dataToChild.name.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_NAME ? 'has-text-info'  : 'has-text-danger' " 
                              v-if="dataToChild.name && dataToChild.name.length>0">
                               (  {{dataToChild.name.length}}/{{GLOBAL_VAR.MAX_PATHO_MEMBER_NAME}} ) 
                            </span>
                        </template>  
                        <b-input v-model="dataToChild.name" placeholder="โรงพยาบาล"></b-input>
                </b-field>

                <b-field label="house_address"
                         horizontal
                         :type="dataToChild.house_address.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_HOUSE_ADDRESS   ? '' : 'is-danger'"
                         :message="dataToChild.house_address.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_HOUSE_ADDRESS    ? '' : 'invalid'"
                          >
                        <template #label>
                           บ้านเลขที่  <span class="has-text-danger">*</span>  

                           <span :class="dataToChild.house_address.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_HOUSE_ADDRESS ? 'has-text-info'  : 'has-text-danger' " 
                              v-if="dataToChild.house_address && dataToChild.house_address.length>0">
                               (  {{dataToChild.house_address.length}}/{{GLOBAL_VAR.MAX_PATHO_MEMBER_HOUSE_ADDRESS}} ) 
                            </span>

                        </template>  
                        <b-input v-model="dataToChild.house_address" placeholder="21/239"></b-input>
                </b-field>


                <b-field label="address_txt"
                         horizontal
                         :type="dataToChild.address_txt.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_ADDRESS_TXT   ? '' : 'is-danger'"
                         :message="dataToChild.address_txt.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_ADDRESS_TXT    ? '' : 'invalid'"
                         >
                        <template #label>
                           ที่อยู่  <span class="has-text-danger">*</span> 
                           <span :class="dataToChild.address_txt.length<=GLOBAL_VAR.MAX_PATHO_MEMBER_ADDRESS_TXT ? 'has-text-info'  : 'has-text-danger' " 
                              v-if="dataToChild.address_txt && dataToChild.address_txt.length>0">
                               (  {{dataToChild.address_txt.length}}/{{GLOBAL_VAR.MAX_PATHO_MEMBER_ADDRESS_TXT}} ) 
                            </span> 
                        </template>  
                        <b-input v-model="dataToChild.address_txt" placeholder=" หมู่บ้านสุวรรณประสิทธิ์ ซอยนวมินทร์ 42 ถนนนวมินทร์"></b-input>
                </b-field>

<!-- {{ this.tumbonSelected }}


{{this.ampurSelected}}
{{this.provinceSelected}} -->

                <b-field label="address_txt"
                         horizontal >
                        <template #label>
                           จังหวัด  <span class="has-text-danger">*</span>  
                        </template>  
                        <b-autocomplete
                                v-model="provinceAutocomplete"
                                :data="filteredProvince"
                                placeholder="e.g. กรุงเทพมหานคร"
                                icon="magnify"
                                :open-on-focus=true
                                clearable
                                field="name"
                                @input = "newTypingAutocompleteProvince"
                                @select="option => (provinceSelected = option)"
                                >
                                 <template slot="empty">No results found </template>
                        </b-autocomplete>
                </b-field>


                <b-field label="address_txt"
                         horizontal  v-if="provinceSelected">
                        <template #label>
                           อำเภอ  <span class="has-text-danger">*</span>  
                        </template>  
                        <b-autocomplete
                                v-model="ampurAutocomplete"
                                :data="filteredAmpur"
                                placeholder="e.g. บางชัน"
                                icon="magnify"
                                :open-on-focus=true
                                clearable
                                field="name"
                                @input = "newTypingAutocompleteAmpur"
                                @select="option => (ampurSelected = option)"
                                >
                                 <template slot="empty">No results found </template>
                        </b-autocomplete>
                </b-field>


                <b-field label="address_txt"
                         horizontal  v-if="ampurSelected">
                        <template #label>
                           ตำบล  <span class="has-text-danger">*</span>  
                        </template>  
                        <b-autocomplete
                                v-model="tumbonAutocomplete"
                                :data="filteredTumbon"
                                placeholder="e.g. คลองกุ่ม"
                                icon="magnify"
                                :open-on-focus=true
                                clearable
                                field="name"
                                @input = "newTypingAutocompleteTumbon"
                                @select="option => (tumbonSelected = option)"
                                >
                                <template slot="empty">No results found </template>
                        </b-autocomplete>
                </b-field>


                <b-field label="address_txt"
                         horizontal>
                        <template #label>
                           โทรศัพท์   
                        </template>  
                        <b-input v-model="dataToChild.phone1"  placeholder="0840072930" ></b-input>
                </b-field>


                <b-field label="address_txt"
                         horizontal>
                        <template #label>
                           Card ID   
                        </template>  
                        <b-input v-model="dataToChild.card_id"  placeholder="3100166487051" ></b-input>
                </b-field>


                <b-field label="address_txt"
                         horizontal>
                        <template #label>
                           Tax ID   
                        </template>  
                        <b-input v-model="dataToChild.tax_id"  placeholder="010405547055" ></b-input>
                </b-field>


                <b-field label="address_txt"
                         horizontal>
                        <template #label>
                           สถานะ 
                        </template>  
                        <b-switch v-model="dataToChild.enabled"
                           >
                         {{dataToChild.enabled ? 'ใช้งาน' : 'ยกเลิก'}}
                        </b-switch>
                </b-field>




            </section>


            <footer class="modal-card-foot"  style="justify-content: space-between;">
                <b-button type="is-danger" @click="close"  icon-left="close"  >Close</b-button>
                <b-button type="is-success" @click="save"  icon-left="upload"  :disabled="!readyToSave">Save</b-button>
            </footer>



        </div>
    
</template>


<script>
import {   mapState  } from "vuex";
import { MAX_PATHO_MEMBER_ID ,  MAX_PATHO_MEMBER_NAME , MAX_PATHO_MEMBER_HOUSE_ADDRESS , MAX_PATHO_MEMBER_ADDRESS_TXT ,  } from '@/utils.js'
import axios from "axios"
import { getBaseURLforBackEnd , getConfigAxios    } from '@/utils.js'


export default {
    name : "AddEditMemberPatho",
    props:{
        dataToChild : Object, 
            //         {
            //     "id" : "",    
            //     "name" : "โรงพยาบาลสัตว์ทองหล่อ",
            //     "member_id" : "TLOR001"
            // }
        mode : Number, // 0 -> new insert mode , 1 -> edit mode   
        isShowing : Boolean,
    },
    computed:{
            ...mapState({
                access_token: state => state.master_data.access_token ,

                province: state => state.master_data.province ,
                ampur: state => state.master_data.ampur ,
                tumbon: state => state.master_data.tumbon ,
            }) ,
            GLOBAL_VAR(){
                return { MAX_PATHO_MEMBER_ID,
                         MAX_PATHO_MEMBER_NAME,
                         MAX_PATHO_MEMBER_HOUSE_ADDRESS,
                         MAX_PATHO_MEMBER_ADDRESS_TXT ,}
            },

            readyToSave(){

               // //    member_id 
               // if(this.dataToChild.member_id.length==0){
               //  return false
               // } 
               if(this.dataToChild.member_id.length>MAX_PATHO_MEMBER_ID ){
                return false
               } 
               
               // member name   
               if(this.dataToChild.name.length==0){
                return false
               } 
               if(this.dataToChild.name.length>MAX_PATHO_MEMBER_NAME ){
                return false
               } 

               // member house address   
               if(this.dataToChild.house_address.length==0){
                return false
               } 
               if(this.dataToChild.house_address.length>MAX_PATHO_MEMBER_HOUSE_ADDRESS ){
                return false
               } 

               // member address   
               if(this.dataToChild.address_txt.length==0){
                return false
               } 
               if(this.dataToChild.address_txt.length>MAX_PATHO_MEMBER_ADDRESS_TXT ){
                return false
               } 

               // member province/ampur/tumbon
               if(this.dataToChild.tumbon_p == null){
                  return false
               }



               return  true
            } ,

            filteredProvince(){
                 return this.province.filter((_province) => {
                     
                    return  _province.name
                            .toString()
                            .toUpperCase()
                            .indexOf(this.provinceAutocomplete.toUpperCase()) >= 0
                })
            },
            filteredAmpur(){
                 const ampurInProvince =  this.ampur.filter(dat=>dat.idprovince == this.provinceSelected)
                 return ampurInProvince.filter((_ampur) => {
                     
                    return  _ampur.name  
                            .toString()
                            .toUpperCase()
                            .indexOf(this.ampurAutocomplete.toUpperCase()) >= 0
                })
            },

            filteredTumbon(){
                 const tumbonInAmpur =  this.tumbon.filter(dat=>dat.idampur == this.ampurSelected)
                 return tumbonInAmpur.filter((_tumbon) => {
                     
                    return  _tumbon.name  
                            .toString()
                            .toUpperCase()
                            .indexOf(this.tumbonAutocomplete.toUpperCase()) >= 0
                })
            },

    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    methods:{
     save(){
        // add new
        //              {
        // 	      "name" : "โรงพยาบาลสัตว์ทองหล่อ สาขา 01",
        //           "member_id" : "tlOR005",
        //           "house_address" : "21/239",
        //           "address_txt": "ซอย นวมินทร์ 42 ถนน นวมินทร์",
        //           "phone1": "0840072930",
        //           "tumbon_p": "13050200",
        //           "enabled"  : true
        //  }
        



        // edit
        //         {  
        //     "id" : 1, 
        // 	"name" : "โรงพยาบาลสัตว์ทิพย์พิมาน",
        //     "enabled" : true,
        //     "house_address" : "21/239",
        //     "address_txt": "ซอย นวมินทร์ 42 ถนน นวมินทร์",
        //     "phone1": "0840072930",
        //     "tumbon_p": "13050200"
        // }


        this.isLoadingFullPage = true 
        let datTo = {}
        let endPoint = ""
        // add new
        if(this.mode == 0){
             datTo = Object.assign({},{
                                    "name" : this.dataToChild.name,
                                    // "member_id" : this.dataToChild.member_id,
                                    "house_address" : this.dataToChild.house_address,
                                    "address_txt": this.dataToChild.address_txt,
                                    "phone1": this.dataToChild.phone1,
                                    "tumbon_p": this.dataToChild.tumbon_p,
                                    "enabled"  : this.dataToChild.enabled,
                                    "card_id": this.dataToChild.card_id == "" ? null : this.dataToChild.card_id,
                                    "tax_id": this.dataToChild.tax_id == "" ? null : this.dataToChild.tax_id 
             })
             endPoint = 'addnewmemberpatho' 
        }
        // edit 
        if(this.mode == 1){
             datTo = Object.assign({},{
                                    "id" : this.dataToChild.id, 
                                    "name" :  this.dataToChild.name,
                                    "enabled" :  this.dataToChild.enabled,
                                    "house_address" : this.dataToChild.house_address,
                                    "address_txt": this.dataToChild.address_txt,
                                    "phone1": this.dataToChild.phone1,
                                    "tumbon_p": this.dataToChild.tumbon_p,
                                    "card_id": this.dataToChild.card_id == "" ? null : this.dataToChild.card_id,
                                    "tax_id": this.dataToChild.tax_id == "" ? null : this.dataToChild.tax_id 
             })
             endPoint = 'editmemberpatho' 
        }

        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
        axios.post(`${getBaseURLforBackEnd()}/api/${endPoint}`,datTo,getConfigAxios())
              .then((res)=>{  
                          const msg = this.mode == 0 ?  `success with ${res.data.member_id}` :  `${res.data.member_name} was ${res.data.msg}`
                          this.isLoadingFullPage = false
                                      this.$buefy.snackbar.open({
                                       duration: 1000,
                                       message: msg,
                                       type: 'is-danger',
                                       position: 'is-bottom-left',
                                       queue: false,
                                    })
                          this.$emit('closeWithUpdate')
              }) 
              .catch((err)=>{
                          this.isLoadingFullPage = false 
                          this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg}<br/>  ${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle-outline',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                         })
              })




     },   
     newTypingAutocompleteProvince(){
        this.dataToChild.tumbon_p = null
        const memberProvince = this.province.find(memberProvince => memberProvince.name === this.provinceAutocomplete  )
                if(memberProvince){
                    this.provinceSelected = memberProvince.id
                }else{
                    this.provinceSelected = null
        }
     },   

     newTypingAutocompleteAmpur(){
        this.dataToChild.tumbon_p = null
        const memberAmpur = this.ampur.find(memberAmpur => memberAmpur.name === this.ampurAutocomplete && (this.provinceSelected == memberAmpur.idprovince) )
                if(memberAmpur){
                    this.ampurSelected = memberAmpur.id
                }else{
                    this.ampurSelected = null
        }
     }, 


     newTypingAutocompleteTumbon(){
      //   console.log("this.tumbonAutocomplete -> ",this.tumbonAutocomplete )
       
        const memberTumbon = this.tumbon.find(memberTumbon => ( memberTumbon.name === this.tumbonAutocomplete)  && (this.ampurSelected == memberTumbon.idampur) )
               //  console.log("memberTumbon.name  -> ",  memberTumbon.name )
                if(memberTumbon){
                    this.tumbonSelected = memberTumbon.id
                    this.dataToChild.tumbon_p = this.tumbonSelected 
                }else{
                    this.tumbonSelected = null
                    this.dataToChild.tumbon_p = null
                }
     }, 



     close(){
       this.$emit('close')
     }
    },
    data(){
        return{
            isLoadingFullPage : false,

            provinceAutocomplete: '', 
            provinceSelected: null,

            ampurAutocomplete: '', 
            ampurSelected: null,

            tumbonAutocomplete: '', 
            tumbonSelected: null,
        }
    },
    watch:{
          provinceSelected :{
            immediate: true,
            handler: function(val){
                  if(val === null){
                     this.ampurSelected = null  
                     this.ampurAutocomplete = ""
        

                     this.tumbonAutocomplete = ''
                     this.tumbonSelected = null


                  }
            }
          },
          ampurSelected :{
             immediate: true,
             handler: function(val){
              if(val === null){
                     //this.tumbonAutocompleteSelected = null
                     this.tumbonAutocomplete = ''
                     this.tumbonSelected = null
              }
             }
          },

         isShowing:{
            immediate: true,
             handler: function(val){
               if(val&&this.mode==1){
                  if(this.dataToChild.tumbon_p != null || this.dataToChild.tumbon_p != '' ){
                    this.tumbonSelected = this.dataToChild.tumbon_p
                    //  
                    const TUMBON_OBJ = this.tumbon.find(dat=>dat.id == this.tumbonSelected )
                    this.tumbonAutocomplete = TUMBON_OBJ.name
                    this.ampurSelected = TUMBON_OBJ.idampur
                    // 
                    const AMPUR_OBJ = this.ampur.find(dat=>dat.id == this.ampurSelected )
                    this.ampurAutocomplete = AMPUR_OBJ.name
                    this.provinceSelected = AMPUR_OBJ.idprovince
                    //
                    const PROVINCE_OBJ = this.province.find(dat=>dat.id == this.provinceSelected )
                    this.provinceAutocomplete = PROVINCE_OBJ.name
                  }
               }
             }    
         } 
    }
}
</script>